<template>
  <div class="join_us_carousel">
    <div class="prev_btn" @click ="prev"></div>

    <div class="big-wapper" style="overflow: hidden">
        <div class="carousel_container">
          <el-carousel :interval="5000" arrow="never" direction="vertical" class="carousel_con" ref = "joinCarousel">
            <el-carousel-item v-for="(item,index) in JoinUsList" :key = index>
               <div class="bigItem">
                   <div class="clearfix item" v-for="(itemInnter,index) in item" :key="index">
                     <div class="position" @click="goPositionDetail(itemInnter.id)">
                       <div class="position_name">{{itemInnter.positionTitle}}</div>
                       <div class="position_num">工作地点：<span>{{itemInnter.location}}</span> / 招聘人数：<span>{{itemInnter.recruitNum}}</span>人</div>
                     </div>
                     <a class="more" @click="goPositionDetail(itemInnter.id)">MORE ></a>
                   </div>
               </div>
            </el-carousel-item>
          </el-carousel>
        </div>
    </div>
    <div class="next_btn" @click ="next"></div>
  </div>
</template>

<script>
  import { GetJoinUs } from '../views/Home/Home.model';
    export default {
        name: "Joincarousel",
      data(){
           return{
             JoinUsList:[]
           }
      },
       methods:{
         prev(){
           this.$refs.joinCarousel.prev();
         },
         next(){
           this.$refs.joinCarousel.next();
         },
         goToJoinUsDetail(){
           this.$router.push({path:"/joinUs"});
         },
         goPositionDetail(posId){
           this.$router.push({path:"/JobDetail",query:{posId:posId}});
         }
       },
      async mounted(){
        let param = {
            page:1,
            limit:0
        };
        let JoinUsData = await  GetJoinUs(param);
        var  tempContainer = [];
        JoinUsData.data.list.forEach(function(item,index){
          var  num = Math.floor(index /3);
          if(!tempContainer[num]){
            tempContainer[num] = [];
          }
          tempContainer[num].push(item);
        });
        this.JoinUsList = tempContainer;
      }
    }
</script>

<style scoped lang="less">
  .prev_btn{
    margin: 24px auto;
    width: 32px;
    height: 22px;
    background: url("~@/assets/image/joinus_up.png")  no-repeat center center;
    background-size:contain;
    &:hover{
    background: url("~@/assets/image/joinus_up_hover.png")  no-repeat center center;
      background-size:contain;
    }
  }
  .next_btn{
    margin: 24px auto;
    width: 32px;
    height: 22px;
    background: url("~@/assets/image/joinus_down.png")  no-repeat center center;
    background-size:contain;
    &:hover{
      background: url("~@/assets/image/joinus_down_hover.png")  no-repeat center center;
      background-size:contain;
    }
  }


  .join_us_carousel{
    position: absolute;
    right: 70px;
    width: 456px;
  }
  .big-wapper{
    background-color: #fff;
    padding: 30px;
    height: 247px;
  }
  .carousel_container{
    font-size: 14px;
    height: 100%;
    img{
       text-align: center;
    }
    .carousel_con{
      background-color: #fff;
      height: 197px;

    }
    .position{
      float: left;
      text-align: left;
      overflow: hidden;
    }
    .carousel_con{
       height: 100%;
    }
    .bigItem{
       height: 260px
    }
    .position_name{
      color:#333;
      font-size: 18px;
      margin-top:4px;
    }
    .position_num{
      color: #999;
      margin-top: 5px;
    }
    .more{
      float: right;
      color:#999;
      margin-top:15px;
      font-size: 14px;
       vertical-align: middle;
      text-decoration: none;
      cursor: pointer;
      &:hover{
         color:#39B2EC;

      }
    }

    .item{
       border-bottom:1px solid #D9D9D9;
       box-sizing: border-box;
       overflow: hidden;
       padding: 15px 0px;
      &:last-child{
         border-bottom: none;
      }
    }
  }

</style>
